import { render, staticRenderFns } from "./shows-guest-table-params.vue?vue&type=template&id=196c8b08&"
import script from "./shows-guest-table-params.vue?vue&type=script&lang=ts&"
export * from "./shows-guest-table-params.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports